import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaChevronDown, FaHandshake, FaUsers, FaCalculator, FaCheckCircle, FaLaptopCode, FaBoxes } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isModulesDropdownOpen, setIsModulesDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsModulesDropdownOpen(false);
  }, [location]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isModulesDropdownOpen &&
        !event.target.closest('.modules-dropdown') &&
        !event.target.closest('.mobile-modules-dropdown')
      ) {
        setIsModulesDropdownOpen(false);
      }
    };

    if (isModulesDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isModulesDropdownOpen]);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isMobileMenuOpen]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''} ${isMobileMenuOpen ? 'menu-open' : ''}`}>
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo">
            <img src="/flowSky.png" alt="FlowSky CRM" className="logo-img" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              Ana Sayfa
            </Link>
            
            {/* Modules Dropdown */}
            <div 
              className="modules-dropdown"
              onMouseEnter={() => setIsModulesDropdownOpen(true)}
              onMouseLeave={() => setIsModulesDropdownOpen(false)}
            >
              <button 
                className={`nav-link nav-link-dropdown ${isActive('/moduller') ? 'active' : ''}`}
                onClick={(e) => {
                  e.preventDefault();
                  setIsModulesDropdownOpen(!isModulesDropdownOpen);
                }}
              >
                Modüller
                <FaChevronDown className={`dropdown-icon ${isModulesDropdownOpen ? 'open' : ''}`} />
              </button>
              
              {isModulesDropdownOpen && (
                <div 
                  className="dropdown-menu"
                  onMouseEnter={() => setIsModulesDropdownOpen(true)}
                  onMouseLeave={() => setIsModulesDropdownOpen(false)}
                >
                  <Link to="/moduller#satis" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                    <FaHandshake className="dropdown-item-icon" />
                    <span>Satış</span>
                  </Link>
                  <Link to="/moduller#insan-kaynaklari" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                    <FaUsers className="dropdown-item-icon" />
                    <span>İnsan Kaynakları</span>
                  </Link>
                  <Link to="/moduller#muhasebe" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                    <FaCalculator className="dropdown-item-icon" />
                    <span>Muhasebe</span>
                  </Link>
                  <Link to="/moduller#kalite" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                    <FaCheckCircle className="dropdown-item-icon" />
                    <span>Kalite</span>
                  </Link>
                  <Link to="/moduller#bilgi-teknolojileri" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                    <FaLaptopCode className="dropdown-item-icon" />
                    <span>Bilgi Teknolojileri</span>
                  </Link>
                  <Link to="/moduller#envanter" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                    <FaBoxes className="dropdown-item-icon" />
                    <span>Envanter</span>
                  </Link>
                </div>
              )}
            </div>

            <Link to="/hakkimizda" className={`nav-link ${isActive('/hakkimizda') ? 'active' : ''}`}>
              Hakkımızda
            </Link>
            <Link to="/iletisim" className={`nav-link ${isActive('/iletisim') ? 'active' : ''}`}>
              İletişim
            </Link>
          </nav>

          {/* CTA Button */}
          <div className="header-cta">
            <Link to="/iletisim" className="header-cta-btn">
              Ücretsiz Deneyin
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={toggleMobileMenu}
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className={`nav-mobile ${isMobileMenuOpen ? 'open' : ''}`}>
          <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
            Ana Sayfa
          </Link>
          
          {/* Mobile Modules Dropdown */}
          <div className="mobile-modules-dropdown">
            <button 
              className={`nav-link nav-link-dropdown ${isActive('/moduller') ? 'active' : ''}`}
              onClick={() => setIsModulesDropdownOpen(!isModulesDropdownOpen)}
            >
              Modüller
              <FaChevronDown className={`dropdown-icon ${isModulesDropdownOpen ? 'open' : ''}`} />
            </button>
            
            {isModulesDropdownOpen && (
              <div className="mobile-dropdown-menu">
                <Link to="/moduller#satis" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                  <FaHandshake className="dropdown-item-icon" />
                  <span>Satış</span>
                </Link>
                <Link to="/moduller#insan-kaynaklari" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                  <FaUsers className="dropdown-item-icon" />
                  <span>İnsan Kaynakları</span>
                </Link>
                <Link to="/moduller#muhasebe" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                  <FaCalculator className="dropdown-item-icon" />
                  <span>Muhasebe</span>
                </Link>
                <Link to="/moduller#kalite" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                  <FaCheckCircle className="dropdown-item-icon" />
                  <span>Kalite</span>
                </Link>
                <Link to="/moduller#bilgi-teknolojileri" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                  <FaLaptopCode className="dropdown-item-icon" />
                  <span>Bilgi Teknolojileri</span>
                </Link>
                <Link to="/moduller#envanter" className="dropdown-item" onClick={() => setIsModulesDropdownOpen(false)}>
                  <FaBoxes className="dropdown-item-icon" />
                  <span>Envanter</span>
                </Link>
              </div>
            )}
          </div>

          <Link to="/hakkimizda" className={`nav-link ${isActive('/hakkimizda') ? 'active' : ''}`}>
            Hakkımızda
          </Link>
          <Link to="/iletisim" className={`nav-link ${isActive('/iletisim') ? 'active' : ''}`}>
            İletişim
          </Link>
          <Link to="/iletisim" className="btn btn-primary btn-mobile">
            Ücretsiz Deneyin
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;

